/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./frens.vue?vue&type=template&id=cef4cc08&scoped=true"
import script from "./frens.vue?vue&type=script&lang=js"
export * from "./frens.vue?vue&type=script&lang=js"
import style0 from "./frens.vue?vue&type=style&index=0&id=cef4cc08&prod&lang=scss"
import style1 from "./frens.vue?vue&type=style&index=1&id=cef4cc08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef4cc08",
  null
  
)

export default component.exports